import { useEffect, useState } from 'react';

// ----------------------------------------------------------------------

/** True once the window has scrolled past `top` pixels. */
export default function useOffSetTop(top = 100): boolean {
  const [offsetTop, setOffSetTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setOffSetTop(window.pageYOffset > top);

    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [top]);

  return offsetTop;
}
